<template>
  <header class="header">
    <div class="nav-container">
      <slot name="nav"> </slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppBar',
};
</script>
